import React, { useContext, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useTranslator from "../../hooks/useTranslator";
import {
  calculateEffortRate,
  convertCurrencyFormat,
  getCustomIncome,
  getIncomeForEffortRate,
  haveValue,
} from "../../helper/common";
import AuthContext from "../../context/auth/AuthContext";
import AwardPropertyPopup from "./AwardPropertyPopup";
import { Link, useNavigate } from "react-router-dom";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "react-toastify";

const LinkedPropertiesPopup = ({
  detailsShow,
  setDetailsShow,
  setPropData,
  property,
  selectBtn,
  tanentData,
  preselectedTanents,
  handlePropSelect,
  handleSaveChanges,
  saveTanentLoading,
  tenantChanged,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const landLordContext = useContext(LandLordContext);
  const { user } = authContext;
  const { multiPropAward, sendInvitationToTenant } = landLordContext;

  const [awardPopupModal, setAwardPopupModal] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [sharerEmail, setSharerEmail] = useState(null);
  const [sharerName, setSharerName] = useState(null);
  const [sendInvitationLoading, setSendInvitationLoading] = useState(false);

  // const calculateRentAmount = (tenantData) => {
  //   if (
  //     haveValue(tenantData?.rent_from_income) &&
  //     haveValue(tenantData?.rent_percentage)
  //   ) {
  //     if (tenantData?.rent_from_income == "current_annual_income") {
  //       return (
  //         convertCurrencyFormat(
  //           Math.floor(
  //             (tenantData?.tenantid?.current_annual_income || 0) *
  //               tenantData?.rent_percentage
  //           ) / 1200
  //         ) || 0
  //       );
  //     } else if (tenantData?.rent_from_income == "itr_amount") {
  //       return (
  //         convertCurrencyFormat(
  //           Math.floor(
  //             (tenantData?.tenantid?.itr_amount || 0) *
  //               tenantData?.rent_percentage
  //           ) / 1200
  //         ) || 0
  //       );
  //     } else if (tenantData?.rent_from_income == "recordedSalary") {
  //       const recordedSal = checkSalary(tenantData?.tenantid);
  //       return (
  //         convertCurrencyFormat(
  //           Math.floor(
  //             ((recordedSal?.salary || 0) * tenantData?.rent_percentage) / 1200
  //           )
  //         ) || 0
  //       );
  //     }
  //   } else {
  //     const doc_type = user?.rent_from || "current_annual_income";
  //     const rentPercentage = user?.rent_percentage;
  //     if (doc_type == "current_annual_income") {
  //       return (
  //         convertCurrencyFormat(
  //           Math.floor(
  //             ((tenantData?.tenantid?.current_annual_income || 0) *
  //               rentPercentage) /
  //               1200
  //           )
  //         ) || 0
  //       );
  //     } else if (doc_type == "itr_amount") {
  //       return (
  //         convertCurrencyFormat(
  //           Math.floor(
  //             ((tenantData?.tenantid?.itr_amount || 0) * rentPercentage) / 1200
  //           )
  //         ) || 0
  //       );
  //     } else if (doc_type == "recordedSalary") {
  //       const recordedSal = checkSalary(tenantData?.tenantid);
  //       return (
  //         convertCurrencyFormat(
  //           Math.floor(((recordedSal?.salary || 0) * rentPercentage) / 1200)
  //         ) || 0
  //       );
  //     }
  //   }
  // };

  const calculateRentAmount = (fullinfo) => {
    const user_income_sources = fullinfo?.income_selection;
    const gurantor_income_sources = user_income_sources?.guarantor_sources;

    const user_income = getCustomIncome(
      fullinfo?.tenantid,
      user,
      _t,
      user_income_sources?.tenant_source
    );

    // gurantor's income
    let totalGurantorIncome = 0;
    let allGurantorIncomes = [];
    let allGurantors = fullinfo?.tenantid?.gurantor_id;

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncome(
            gurantor,
            user,
            _t,
            gurantor_income_sources?.[gurantor?._id]
          );
          totalGurantorIncome += income?.amount || 0;
          allGurantorIncomes.push(income);
        }
      });
    }

    const combinedIncome = user_income?.amount + totalGurantorIncome;

    let temp_obj = calculateEffortRate(combinedIncome, user, fullinfo);

    return !Number.isNaN(temp_obj?.effort_amount)
      ? Math.round(Number(temp_obj.effort_amount))
      : 0;
  };

  const handleCheckboxChange = (tenantData) => (e) => {
    const isChecked = e.target.checked;
    setSelectedTenant((prev) => {
      if (isChecked) {
        // Add to list if not already present
        return [...prev, tenantData];
      } else {
        // Remove from list
        return prev.filter((tenant) => tenant.id !== tenantData.id);
      }
    });
  };

  const handleAwardPropFlow = () => {
    // setAwardPopupModal(true);
    setDetailsShow(false);
    if (selectedTenant.length == 1) {
      navigate(
        `/assignProperty/${property?._id}?sharedProfile=${selectedTenant[0]?._id}&step=0`
      );
    } else {
      sendAwardPropEmail();
    }
  };

  const sendAwardPropEmail = () => {
    const send_data = {
      selected_tenants: selectedTenant.map((val) => val?.tenantid),
      property_id: property?._id,
    };

    multiPropAward(send_data)
      .then((res) => {
        setDetailsShow(false);
        if (setPropData) setPropData({});
        setSelectedTenant([]);
        toast.success(
          _t(
            "successWhileAwardingMultiPropAdminWillContactYou",
            "Success text when LL tries to award Multi tenant prop"
          )
        );
      })
      .catch((err) => {
        console.log("Error while awarding MultiProp");
        toast.error(
          _t(
            "errorWhileAwardingMultiProp",
            "Error text when LL tries to award Multi tenant prop"
          )
        );
      });

    console.log("Email should be sent here to admin");
  };

  const sendInvitationViaEmail = async (e) => {
    e.preventDefault();
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(sharerEmail)) {
      setSendInvitationLoading(true);
      try {
        const response = await sendInvitationToTenant({
          type: "email",
          name: sharerName,
          email: sharerEmail,
          property_id: property?._id,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharerEmail(null);
        setShowEmailModal(false);
        setSendInvitationLoading(false);
      }
    } else {
      toast.error(_t("invalidEmailAddress"));
      return false;
    }
  };

  return (
    <>
      <Modal
        show={detailsShow}
        className="metermodal modal-xl modalWidth_set"
        centered
        onHide={(e) => {
          setDetailsShow(false);
          if (setPropData) setPropData({});
          setSelectedTenant([]);
        }}
      >
        <Modal.Body>
          <div className="d-flex justify-content-between assigned_details_modal">
            <div className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10.7068 0.29279L19.7051 9.29291C20.335 9.92291 19.889 10.9999 18.9982 10.9999H17.9984V16.9999C17.9984 17.7956 17.6824 18.5587 17.1199 19.1213C16.5574 19.6839 15.7945 20 14.9989 20H13.9992V12.9999C13.9992 12.2347 13.7069 11.4984 13.182 10.9416C12.6572 10.3849 11.9394 10.0498 11.1756 10.0049L10.9997 9.99988H9.00005C8.20458 9.99988 7.44164 10.3159 6.87917 10.8786C6.31664 11.4412 6.00064 12.2042 6.00064 12.9999V20H5.00082C4.20531 20 3.4424 19.6839 2.87989 19.1213C2.31739 18.5587 2.00137 17.7956 2.00137 16.9999V10.9999H1.00156C0.111727 10.9999 -0.33519 9.92291 0.294693 9.29291L9.29299 0.29279C9.48052 0.105316 9.73476 0 9.99987 0C10.265 0 10.5193 0.105316 10.7068 0.29279ZM10.9997 11.9999C11.2649 11.9999 11.5192 12.1053 11.7067 12.2928C11.8942 12.4804 11.9995 12.7347 11.9995 12.9999V20H8.00029V12.9999C8.00029 12.755 8.09017 12.5186 8.25293 12.3356C8.41564 12.1525 8.63988 12.0356 8.88311 12.0069L9.00005 11.9999H10.9997Z"
                  fill="#253837"
                />
              </svg>
              <p className="assigned_address">
                {property?.street} -{" "}
                {Number.isNaN(parseInt(property?.street_number, 10))
                  ? "N/A"
                  : String(parseInt(property?.street_number, 10))}
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                setDetailsShow(false);
                if (setPropData) setPropData({});
              }}
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.7734 1.32064C16.8453 1.24881 16.9022 1.16352 16.9411 1.06966C16.98 0.975805 17 0.875207 17 0.773615C17 0.672022 16.98 0.571424 16.9411 0.477565C16.9022 0.383706 16.8453 0.298423 16.7734 0.226586C16.7016 0.15475 16.6163 0.0977657 16.5224 0.058888C16.4286 0.0200102 16.328 0 16.2264 0C16.1248 0 16.0242 0.0200102 15.9303 0.058888C15.8365 0.0977657 15.7512 0.15475 15.6794 0.226586L8.5 7.40749L1.32064 0.226586C1.24881 0.15475 1.16352 0.0977657 1.06966 0.058888C0.975805 0.0200102 0.875207 7.56923e-10 0.773615 0C0.672022 -7.56923e-10 0.571424 0.0200102 0.477565 0.058888C0.383706 0.0977657 0.298423 0.15475 0.226586 0.226586C0.15475 0.298423 0.0977657 0.383706 0.058888 0.477565C0.0200102 0.571424 -7.56923e-10 0.672022 0 0.773615C7.56923e-10 0.875207 0.0200102 0.975805 0.058888 1.06966C0.0977657 1.16352 0.15475 1.24881 0.226586 1.32064L7.40749 8.5L0.226586 15.6794C0.0815054 15.8244 0 16.0212 0 16.2264C0 16.4316 0.0815054 16.6283 0.226586 16.7734C0.371667 16.9185 0.568439 17 0.773615 17C0.97879 17 1.17556 16.9185 1.32064 16.7734L8.5 9.59251L15.6794 16.7734C15.8244 16.9185 16.0212 17 16.2264 17C16.4316 17 16.6283 16.9185 16.7734 16.7734C16.9185 16.6283 17 16.4316 17 16.2264C17 16.0212 16.9185 15.8244 16.7734 15.6794L9.59251 8.5L16.7734 1.32064Z"
                fill="black"
              />
            </svg>
          </div>

          <Row className="card-listing mt-0 custm_select_btn mt-2">
            <div className="link-property prime-selectmulti multiselect-tenant">
              <div className="d-flex justify-content-between align-items-center">
                <p className="text-start">{_t("add/removeTenant")}</p>
                {/* <div className="shareQr"> */}
                <a
                  className="btn btngreen invite_tenantbtn invite_tenant_button"
                  href={undefined}
                  onClick={(e) => {
                    setShowEmailModal(true);
                    setDetailsShow(false);
                  }}
                  style={{ maxWidth: "8.5vw" }}
                >
                  {/* <svg
                    width="22"
                    height="22"
                    viewBox="0 0 26 23"
                    className="button_iconset"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.47555 11.6349C5.39143 11.8906 5.34412 12.1623 5.34412 12.4446C5.34412 13.8537 6.47445 15.0018 7.86765 15.0018C9.26086 15.0018 10.3912 13.8564 10.3912 12.4446C10.3912 11.0329 9.26086 9.8875 7.86765 9.8875C7.38398 9.8875 6.93447 10.0287 6.54805 10.2684L4.32156 8.28397L5.17588 7.31439L3.89308 6.15303L3.02825 7.13326L2.42628 6.5952L3.33843 5.56169L2.05563 4.40033L1.13296 5.44449L1.03307 5.55903L0.509965 6.15303L0.515222 6.15835L0 6.75502L5.47818 11.6349H5.47555ZM7.86765 11.6295C8.30927 11.6295 8.67203 11.9945 8.67203 12.442C8.67203 12.8895 8.3119 13.2544 7.86765 13.2544C7.42341 13.2544 7.06591 12.8895 7.06591 12.442C7.06591 11.9945 7.42603 11.6295 7.86765 11.6295Z"
                      fill="#253837"
                    />
                    <path
                      d="M7.18932 8.98668C7.20246 8.98401 7.52842 8.89611 7.9937 8.89611C8.98208 8.89611 10.3253 9.2637 11.1192 11.0111L11.1744 11.1309L12.7358 10.4011L12.6806 10.2812C11.7448 8.2222 10.1913 7.17804 8.05942 7.17804C7.65197 7.17804 7.21561 7.21799 6.76085 7.29524L6.6189 7.31921L7.06052 9.01598L7.18669 8.98135L7.18932 8.98668Z"
                      fill="#253837"
                    />
                    <path
                      d="M13.3878 1.76544C13.974 2.78296 15.9009 6.37892 16.0612 10.0095L16.0665 10.1454L17.783 10.0068L17.7751 9.87633C17.5701 6.60267 15.9324 2.96942 14.9756 1.09419C14.9466 1.03559 14.9282 1.00096 14.9204 0.984978L14.8651 0.865112L13.3037 1.59762L13.3589 1.71749C13.3589 1.71749 13.3694 1.73614 13.3852 1.76544H13.3878Z"
                      fill="#253837"
                    />
                    <path
                      d="M9.0006 2.0771C9.6788 2.86022 13.0829 6.93831 13.5167 10.2386L13.5351 10.3691L15.2385 10.14L15.2201 10.0095C14.7653 6.53876 11.6897 2.58586 10.3885 1.04626C10.3517 1.00364 10.3281 0.974341 10.3176 0.961023L10.2361 0.85714L8.89282 1.94392L8.97431 2.0478C8.97431 2.0478 8.98483 2.05846 8.99797 2.0771H9.0006Z"
                      fill="#253837"
                    />
                    <path
                      d="M19.0315 2.53771L18.9841 2.41518L17.3859 3.05979L17.4332 3.18232C19.8674 9.37803 20.1171 14.9211 18.1035 18.0083C16.5657 20.3657 13.9949 20.4483 13.8845 20.4509H13.8608C13.6006 20.4642 13.343 20.4696 13.0932 20.4696C10.3515 20.4696 8.21968 19.7131 6.75024 18.2214C4.28716 15.7202 4.25562 11.9645 4.25562 11.9298L4.26088 11.7993L3.40393 11.754L2.54697 11.7061L2.53909 11.8393C2.53909 11.8819 2.49966 16.3569 5.52264 19.4414C7.32592 21.2793 9.87312 22.2143 13.0959 22.2143C13.3693 22.2143 13.6505 22.2063 13.9318 22.193C14.2946 22.1823 17.5357 22.0118 19.523 18.9939C21.8993 15.382 21.7206 9.38336 19.0315 2.53771Z"
                      fill="#253837"
                    />
                    <path
                      d="M22.0475 10.6344C22.0475 10.1503 21.8552 9.686 21.5129 9.34367C21.1705 9.00134 20.7062 8.80902 20.2221 8.80902C19.738 8.80902 19.2737 9.00134 18.9314 9.34367C18.589 9.686 18.3967 10.1503 18.3967 10.6344V12.7614H16.2697C15.7856 12.7614 15.3213 12.9537 14.979 13.296C14.6367 13.6384 14.4443 14.1027 14.4443 14.5868C14.4443 15.0709 14.6367 15.5352 14.979 15.8775C15.3213 16.2199 15.7856 16.4122 16.2697 16.4122H18.3967V18.5392C18.3967 19.0233 18.589 19.4876 18.9314 19.8299C19.2737 20.1723 19.738 20.3646 20.2221 20.3646C20.7062 20.3646 21.1705 20.1723 21.5129 19.8299C21.8552 19.4876 22.0475 19.0233 22.0475 18.5392V16.4122H24.1745C24.6586 16.4122 25.1229 16.2199 25.4652 15.8775C25.8076 15.5352 25.9999 15.0709 25.9999 14.5868C25.9999 14.1027 25.8076 13.6384 25.4652 13.296C25.1229 12.9537 24.6586 12.7614 24.1745 12.7614H22.0475V10.6344Z"
                      fill="#253837"
                      stroke="#A3EB64"
                      stroke-width="2"
                    />
                  </svg> */}
                  <img
                    src="/images/invite-tenant-icon.svg"
                    className="vw-me-2"
                    alt=""
                  />
                  {_t("requestProfile")}
                </a>
                {/* </div> */}
              </div>
              <ReactMultiSelectCheckboxes
                isMulti
                name="link_property"
                id="link_property"
                options={tanentData}
                className="basic-multi-select form-control link_prop_select"
                classNamePrefix="select"
                placeholderButtonLabel={selectBtn}
                getDropdownButtonLabel={function getDropdownButtonLabel(_ref3) {
                  return selectBtn;
                }}
                selectedOptions={preselectedTanents}
                onChange={handlePropSelect}
                defaultValue={preselectedTanents}
              />

              {tenantChanged && (
                <button
                  type="button"
                  className="btn btngreen save-btn"
                  onClick={handleSaveChanges}
                  disabled={
                    !tenantChanged ||
                    tanentData.length === 0 ||
                    saveTanentLoading
                  }
                >
                  {_t(
                    "linkTextButton",
                    "On LL side when selecting tenants to be linked with a property"
                  )}
                </button>
              )}
            </div>
          </Row>

          <div className="assigned_details_body ">
            <p className="linked_p_details">
              {_t("linkedTo")}
              <span>{property.sharedProfiles.length || 0}</span>
            </p>
          </div>

          <div className="mobile-single-property">
            <ul>
              {/* {console.log("CHECKDETAILSHERE", property.sharedProfiles)} */}
              {property.sharedProfiles.map((assignPropData) => (
                <li className="d-flex linked_li_details linked_li_details2">
                  <div className="d-flex w-full justifycontent">
                    <div className="linked_li_div d-flex">
                      <input
                        className="checkbox_box"
                        type="checkbox"
                        checked={selectedTenant.includes(assignPropData)}
                        onChange={handleCheckboxChange(assignPropData)}
                      />
                      <div>
                        <p
                          onClick={() => {
                            user?.isParentLL
                              ? navigate(
                                  `/profile-property?agencylink=${assignPropData?.agency_tenant_link_id}`
                                )
                              : navigate(
                                  `/profile-property?sharedprofileid=${assignPropData?._id}`
                                );
                          }}
                          className="linked_li_name d-flex gap-2 align-items-center cursor-pointer"
                        >
                          {assignPropData?.tenantid?.fname || ""}{" "}
                          {assignPropData?.tenantid?.lname || ""}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="7"
                            height="11"
                            viewBox="0 0 8 13"
                            fill="none"
                          >
                            <path
                              d="M1 12L7 6.5L1 1"
                              stroke="#253837"
                              stroke-width="1.4"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </p>
                        <p className="linked_li_score">
                          {_t("profile")}:{" "}
                          {assignPropData?.tenantid?.paymentScores?.creditScore
                            ?.value || 0}
                        </p>
                      </div>
                    </div>
                    <div className="linked_li_rate">
                      <p>
                        {_t("maxRent")}: {calculateRentAmount(assignPropData)}{" "}
                        {/* {haveValue(assignPropData?.rent_percentage)
                          ? ` [${assignPropData?.rent_percentage}%]`
                          : ""} */}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <div className="buttonset_css">
              {selectedTenant.length > 0 && (
                <button
                  onClick={() => {
                    setAwardPopupModal(true);
                    setDetailsShow(false);
                  }}
                  type="button"
                  className="btn btngreen buttonset_css_clrchange"
                >
                  {_t("generateReport")}
                </button>
              )}
              {selectedTenant.length > 0 && (
                <button
                  onClick={() => {
                    handleAwardPropFlow();
                  }}
                  type="button"
                  className="btn btngreen"
                >
                  {_t("awardProperty")}
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <AwardPropertyPopup
        awardPopupModal={awardPopupModal}
        setAwardPopupModal={setAwardPopupModal}
        selectedTenants={selectedTenant}
        property={property}
      />
      <Modal
        show={showEmailModal}
        onHide={(e) => setShowEmailModal(false)}
        centered
        className="newmodalui max-w-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("email")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="qr-link-copi"> */}
          <form
            onSubmit={sendInvitationViaEmail}
            className="d-flex flex-wrap mt-5 justify-content-center"
          >
            <div className="form-group col-6 px-1 bodyContentset">
              <input
                type="text"
                onChange={(e) => {
                  setSharerName(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("name")}
              />
            </div>
            <div className="form-group col-6 px-1 bodyContentset">
              <input
                type="email"
                onChange={(e) => {
                  setSharerEmail(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("email")}
              />
            </div>
            <div className="col-12 mt-3  d-flex justify-content-center">
              <button
                type="submit"
                className="btn btngreen"
                disabled={sendInvitationLoading}
              >
                {_t("sendInvitation")}
              </button>
            </div>
          </form>
          {/* </div> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LinkedPropertiesPopup;
